"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRCode = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactI18next = require("react-i18next");
var _utils = require("../../../../../utils");
var _ui = require("../../../../ui");
var _hooks = require("../../../../../hooks");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Description = (0, _styledComponents.default)(_ui.H4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 340px;\n  margin: 0 auto 30px;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    margin-bottom: 10px;\n  "]))));
var QRCode = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var _useReplenishContext = (0, _hooks.useReplenishContext)(),
    crypto = _useReplenishContext.crypto;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.MediumSpan, null, /*#__PURE__*/_react.default.createElement(Description, null, t(crypto.address ? 'scanText' : 'scanTextNotRevealed'))), /*#__PURE__*/_react.default.createElement(_ui.QRCodeBlockchain, {
    size: 188,
    address: crypto.address,
    blockchain: crypto.blockchain,
    onClick: function onClick() {
      if (!crypto.revealDisabled) crypto.onReveal();
    }
  }));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  text-align: center;\n"])));
exports.QRCode = QRCode;